import { createSyncAction } from '@bimser/core';
import { RESET_DATA } from './actionTypes';

export default function resetSearchDataAction() {
	return createSyncAction(RESET_DATA, null);
}
